'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterXSS = undefined;

var _reactPureCheck = require('react-pure-check'); // XSS filter


var filterXSS = function filterXSS() {
  var dangerStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var replacePatten = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if ((0, _reactPureCheck.Types)(dangerStr) !== "string") return dangerStr;
  return dangerStr.replace(/(\<([\s\S]*)script([\s\S]*)\>|console.log\(([\s\S]*)\)|alert\(([\s\S]*)\))/g, replacePatten);
};
/*
	intro : filter XSS function defination
	Author : chenchao
	Date : 2019-07-05
*/


exports.filterXSS = filterXSS;